export default "__VITE_ASSET__DtoLUaLC__"